import { render, staticRenderFns } from "./Settled.vue?vue&type=template&id=6083e774&scoped=true"
import script from "./Settled.vue?vue&type=script&lang=js"
export * from "./Settled.vue?vue&type=script&lang=js"
import style0 from "./Settled.vue?vue&type=style&index=0&id=6083e774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6083e774",
  null
  
)

export default component.exports